<template>
    <div>
        <!--Header-->
        <div class="p-10 display-flex align-center justify-space-between" style="border-bottom: 1px solid #e4edfa;">
            <!--List actions for current work-->
            <div class="display-flex align-center" v-if="activeCall">
                <!--Button copy call ID-->
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{on}">
                        <div class="btn-tag" @click="copyText(callQCDetail.call_id)" v-on="on">
                            <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                 style="width: 16px; margin-right: 3px">
                            {{ $f.tc('botHistory.callId') }}
                        </div>
                    </template>
                    <span>{{ callQCDetail.call_id }}</span>
                </v-tooltip>
                <!--Button copy start_time call QC-->
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{on}">
                        <div class="btn-tag" @click="copyText(callQCDetail.start_time)" v-on="on">
                            <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                 style="width: 16px; margin-right: 3px">
                            {{ $f.tc('startTime') }}
                        </div>
                    </template>
                    <span>{{ callQCDetail.start_time }}</span>
                </v-tooltip>
                <!--Button copy batch_name-->
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{on}">
                        <div class="btn-tag" @click="copyText(callQCDetail.batch_name)" v-on="on">
                            <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                 style="width: 16px; margin-right: 3px">
                            {{ $f.tc('batch') }}
                        </div>
                    </template>
                    <span>{{ callQCDetail.batch_name }}</span>
                </v-tooltip>
                <!--Button copy call_campaign_name-->
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{on}">
                        <div class="btn-tag" @click="copyText(callQCDetail.call_campaign_name)" v-on="on">
                            <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                 style="width: 16px; margin-right: 3px">
                            {{ $f.tc('campaign') }}
                        </div>
                    </template>
                    <span>{{ callQCDetail.call_campaign_name }}</span>
                </v-tooltip>
                <!--Button copy bot_name-->
                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <div class="btn-tag" @click="copyText(callQCDetail.bot_name)" v-on="on">
                            <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                 style="width: 16px; margin-right: 3px">
                            {{ $f.tc('bot') }}
                        </div>
                    </template>
                    <span>{{ callQCDetail.bot_name }}</span>
                </v-tooltip>
            </div>
            <!--Editing/Viewing mode and more info-->
            <div class="display-flex align-center" v-if="statusCallStatistics">
                <v-scroll-x-reverse-transition>
                    <div class="display-flex align-center" v-show="isShowStatusCallStatistics">
                        <div class="status-tag">
                            <div class="color-status done"></div>
                            {{ statusCallStatistics.done }} - {{ $f.tc('done') }}
                        </div>
                        <div class="status-tag" v-if="isPerformQC">
                            <div class="color-status in-progress"></div>
                            {{ statusCallStatistics.inProgress }} - {{ $f.tc('inProgress') }}
                        </div>
                        <div class="status-tag" v-if="isPerformQC">
                            <div class="color-status todo"></div>
                            {{ statusCallStatistics.todo }} - {{ $f.tc('todo') }}
                        </div>
                    </div>
                </v-scroll-x-reverse-transition>
                <div class="btn-icon btn-info-chart" @click="isShowStatusCallStatistics = !isShowStatusCallStatistics">
                    <v-icon color="#8A97AA">mdi-information</v-icon>
                </div>
                <div v-if="!isPerformQC" class="btn-tag access-status">
                    <img src="/img/view.svg" alt="icon-reviewing">
                    {{ $f.tc('reviewingMode') }}
                </div>
            </div>
        </div>
        <!-- Content page -->
        <div class="display-flex content-page">
            <div class="call-history">
                <!-- Audio -->
                <div class="call-audio" v-if="activeCall">
                    <div class="btn-secondary mr-10" @click="isShowDataInput = !isShowDataInput">
                        {{ $f.tc('dataInput') }}
                    </div>
                    <div class="display-flex align-center" v-if="loadingAudio" style="font-size: 14px;">
                        <v-progress-circular
                            indeterminate
                            width="3"
                            color="#0052CC"
                            class="mr-10"
                            style="width: 18px"
                        ></v-progress-circular>
                        Loading audio...
                    </div>
                    <div v-else class="centerXY" style="background: #f1f3f4; width: 100%; height: 38px;">
                        <audio
                            :src="callQCAudioSrc"
                            controls="controls"
                            ref="audio"
                        ></audio>
                    </div>
                </div>
                <div class="display-flex" style="gap: 10px">
                    <!-- Data input -->
                    <div class="data-input" v-if="isShowDataInput">
                        <table>
                            <thead>
                            <tr>
                                <th>{{ $f.tc('source') }}</th>
                                <th>{{ $f.tc('key') }}</th>
                                <th>{{ $f.tc('value') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, idx) in activeCallInputData" :key="idx">
                                <td>{{ item.source }}</td>
                                <td>{{ item.key }}</td>
                                <td>{{ item.value }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Call history -->
                    <div style="flex: 1">
                        <LoadingBox v-if="loadingMessage" style="height: calc(100vh - 355px)"></LoadingBox>
                        <div v-else class="message-scroll fci-scrollbar" ref="MessageScroll">
                            <!--List message-->
                            <div v-if="activeCallHistory.messageList.length>0">
                                <div v-for="(item, j) in activeCallHistory.messageList" :key="j"
                                     :style="[j !== 0 ? {marginTop: '12px'} : '']">
                                    <div v-if="item.type === 'user'" class="message-container user">
                                        <div
                                            class="message user"
                                            :class="getClassUserMsg(item)"
                                        >
                                            {{ item.content }}
                                        </div>
                                        <div
                                            class="btn-icon"
                                            v-if="asrCriteriaList.length!==0 && !['-----new conversation-----','-----end call-----'].includes(item.content)"
                                            @click="qcSentence(item)"
                                        >
                                            <img src="/img/qc-new.svg" alt="qc" style="width: 14px">
                                        </div>
                                    </div>
                                    <div v-else class="message-container bot">
                                        <div class="message-icon-container">
                                            <img src="/img/scenario/process_active.svg" alt="bot">
                                        </div>
                                        <div class="message bot mx-2">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                    <div v-if="item.nlp" class="nlp-container">
                                        <span v-for="(entity, entityIndex) in item.nlp.entities" :key="entityIndex">
                                            ( {{ entity.entity }} - {{ entity.value }} )
                                        </span>
                                        <span style="color: #8A97AA; margin-right: 3px;">
                                            {{ item.nlp.intent ? item.nlp.intent.label : "" }}
                                        </span>
                                        -
                                        <span
                                            class="nlp-confidence"
                                            :class="checkNLPMapConditions(item.nlp).isValid ? 'nlp-warning' : ''"
                                            :title="checkNLPMapConditions(item.nlp).isValid ? $f.tc('confidenceValidRange', {from: checkNLPMapConditions(item.nlp).from * 100, to: checkNLPMapConditions(item.nlp).to * 100}) : ''"
                                        >
                                            {{ item.nlp.intent ? Math.round(item.nlp.intent.confidence * 100) : 100 }}%
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="centerXY empty-box" style="height: 100%">
                                <div>
                                    <img src="/img/empty-chat.png" style="width: 120px" class="mb-10"
                                         alt="icon-empty-chat">
                                    <div style="text-align: center; font-family: 'open sans',serif; font-size: 14px">
                                        {{ $f.tc('noDataAvailable') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="qc-content" v-if="activeLogId === ''">
                <!--Icon Loading-->
                <div v-if="isLoadingRightEditor" class="p-10" style="height: calc(100vh - 298px)">
                    <LoadingBox></LoadingBox>
                </div>
                <!-- Criteria -->
                <div v-else>
                    <!-- QC Output -->
                    <div class="title-qc">
                        {{ $f.tc('evaluatingCall') }}
                    </div>
                    <div class="p-10 fci-scrollbar" style="height: calc(100vh - 344px); overflow-y: auto">
                        <div v-for="item in criteria" :key="item.id" class="item-qc">
                            <div class="item-criteria">
                                <div class="mr-6">{{ item.name }}</div>
                                <v-tooltip bottom color="#8b8b8b">
                                    <template v-slot:activator="{ on, attrs }">
                                        <img
                                            v-bind="attrs"
                                            v-on="on"
                                            src="/img/notice.svg"
                                            alt="icon-notice"
                                        />
                                    </template>
                                    <div v-for="(d,index) in item.description.split('\n')" :key="`${d}_${index}`"
                                         style="max-width: 350px">
                                        {{ d }}
                                    </div>
                                </v-tooltip>
                            </div>
                            <v-textarea
                                v-if="item.type === 'TEXT'"
                                :readonly="batchStatus === 'close'"
                                v-model="model[item.id]"
                                :rules="item['is_required']?formRules.required:[]"
                                class="textarea-custom"
                                :clearable="!item.is_required"
                                @click:clear="onClearCriteria(item.id, false)"
                            ></v-textarea>
                            <v-autocomplete
                                v-if="item.type !== 'TEXT'"
                                :readonly="batchStatus === 'close'"
                                :items="item.config"
                                :rules="item['is_required']?formRules.required:[]"
                                v-model="model[item.id]"
                                class="input-custom"
                                item-value="value"
                                :clearable="!item.is_required"
                                @click:clear="onClearCriteria(item.id, false)"
                            >
                                <template v-slot:selection="{ item }">
                                    {{ getText(item) }}
                                </template>
                                <template v-slot:item="{ item }">
                                    <div class="display-flex align-center">
                                        {{ item.value }}
                                        <v-chip small>{{ item.description }}</v-chip>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </div>
                    </div>
                </div>
            </div>
            <div class="qc-content" v-else>
                <!-- QC Sentence Output -->
                <div class="title-qc centerY justify-space-between">
                    {{ $f.tc("evaluatingSentence") }}
                    <v-btn icon small class="mx-0">
                        <img
                            src="/img/close.svg"
                            alt="qc"
                            style="width: 20px"
                            @click="closeQcSentence"
                        />
                    </v-btn>
                </div>
                <div class="p-10 fci-scrollbar" style="height: calc(100vh - 400px); overflow-y: auto">
                    <div v-if="asrAudioSrc">
                        <div class="mb-6 font-italic" v-if="asrDateExpired">
                            {{ $f.tc("asrDateExpired", {'expired': asrDateExpired}) }}
                        </div>
                        <div class="centerXY" style="background: #f1f3f4; width: 100%;margin-bottom: 5px">
                            <audio
                                :src="asrAudioSrc"
                                controls="controls"
                                ref="audio"
                                style="height: 38px;width: 100%"
                            ></audio>
                        </div>
                    </div>
                    <div v-for="item in asrCriteria" :key="item.id" class="item-qc">
                        <div class="item-criteria">
                            <div class="mr-6">{{ item.name }}</div>
                            <v-tooltip bottom color="#8b8b8b">
                                <template v-slot:activator="{ on, attrs }">
                                    <img
                                        v-bind="attrs"
                                        v-on="on"
                                        src="/img/notice.svg"
                                        alt="icon-notice"
                                    />
                                </template>
                                <div v-for="(d,index) in item.description.split('\n')" :key="`${d}_${index}`"
                                     style="max-width: 350px">
                                    {{ d }}
                                </div>
                            </v-tooltip>
                        </div>
                        <v-textarea
                            v-if="item.type === 'TEXT'"
                            :readonly="batchStatus === 'close'"
                            v-model="asrModel[item.id]"
                            :rules="item['is_required']?formRules.required:[]"
                            class="textarea-custom"
                            :clearable="!item.is_required"
                            @click:clear="onClearCriteria(item.id)"
                        ></v-textarea>
                        <v-autocomplete
                            v-if="item.type !== 'TEXT'"
                            :readonly="batchStatus === 'close'"
                            :items="item.config"
                            v-model="asrModel[item.id]"
                            class="input-custom"
                            item-value="value"
                            :rules="item['is_required']?formRules.required:[]"
                            :clearable="!item.is_required"
                            @click:clear="onClearCriteria(item.id)"
                        >
                            <template v-slot:selection="{ item }">
                                {{ getText(item) }}
                            </template>
                            <template v-slot:item="{ item }">
                                <div class="display-flex align-center">
                                    {{ item.value }}
                                    <v-chip small>{{ item.description }}</v-chip>
                                </div>
                            </template>
                        </v-autocomplete>
                    </div>
                </div>
                <div class="ml-10 mr-10 mt-10 mb-10 btn-primary" @click="saveRecordSentence">
                    {{ $f.tc('save') }}
                </div>
            </div>
        </div>
        <div class="dialog-footer justify-center">
            <!--Icon Loading-->
            <div class="display-flex align-center">
                <div class="mr-8 btn-primary" @click="saveRecord(false)">
                    {{ $f.tc("save") }}
                </div>
                <div class="btn-primary" @click="nextCall">
                    {{ $f.tc('nextCall') }}
                    <img class="ml-8" src="/img/arrow-right.svg" alt="icon-next">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import lodash from 'lodash'
import QcCampaignService from '@/services/qc.campaign.service'
import {mapState} from 'vuex'
import LoadingBox from '@/components/LoadingBox'
import ScenarioService from '@/services/scenario.service'
import moment from "moment";

const {NodeType} = ScenarioService

export default {
    name: 'QCCurrentWork',
    props: {
        criteriaList: {
            type: Array,
            default: () => []
        },
        asrCriteriaList: {
            type: Array,
            default: () => []
        }
    },
    components: {LoadingBox},
    mixins: [FormMixin],
    data() {
        return {
            NodeType,
            activeCall: {},
            callQCDetail: {},
            activeCallId: '',
            activeCallInputData: [],
            callCampaign: null,
            callQCAudioSrc: '',
            callQCAudio: null,
            callRecords: [],
            activeCallHistory: {
                messageList: []
            },
            batchId: this.$route.query.batchId,
            callList: [],
            criteria: [],
            loadingAudio: false,
            loadingMessage: false,
            model: {},
            qcResult: {},
            isLoadingRightEditor: false,
            isShowDataInput: false,
            statusCallStatistics: null,
            isShowStatusCallStatistics: false,

            // QC sentence
            activeSentenceId: '',
            activeLogId: '',
            activeSentence: {},
            recordSentence: [],
            asrModel: {},
            asrCriteria: [],
            asrAudioSrc: '',
            asrDateExpired: ''
        }
    },
    computed: {
        ...mapState({
            profile: state => state.user.profile,
            indexCall: state => state.qccampaign.indexCall,
            totalCall: state => state.qccampaign.totalCall,
            batch: state => state.qccampaign.batch,
            batchStatus: state => state.qccampaign.batch ? state.qccampaign.batch.status : '',
            isPerformQC: state => state.qccampaign.batch ? state.qccampaign.batch.status !== 'close' : false,
            conditionNLPList: state => {
                if (!state.qccampaign.batch) return []

                const conditions = state.qccampaign.batch?.condition_config?.condition
                if (conditions.length === 0) return []

                return conditions.filter(i => i.field === 'confidence' && i.source === 'nlp')
            },
            callCampaigns: state => state.qccampaign.callCampaigns,
            qcCampaign: state => state.qccampaign.campaign,
        }),
    },
    mounted() {
        // get batch if not exist
        this.getBatch().then(() => {
            // search
            let index = this.$route.query.callIndex ? +this.$route.query.callIndex : 0
            this.$store.commit(this.$actionTypes.qccampaign.SET_INDEX_CALL, index);
            this.search();
            this.convertCriteria();
            this.convertASRCriteria();
            this.getStatusStatistics();
            this.getCampaign()
        })
    },
    methods: {
        getCampaign() {
            this.callCampaign = this.callCampaigns.find(i => i.id === this.qcCampaign["call_campaign_id"])
        },
        getBatch() {
            return QcCampaignService.CallListService.read(this.$route.params.QCCampaignId, this.$route.query.batchId).then(result => {
                this.$store.commit(this.$actionTypes.qccampaign.UPDATE_BATCH, result.data)
            }).catch(error => {
                if (error.response.status === 404) {
                    this.$router.push({
                        path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                        query: {
                            tab: 'batch',
                        }
                    })
                }
            })
        },
        search() {
            if (!this.batchId) {
                return
            }
            let params = {}
            params['index'] = this.indexCall
            QcCampaignService.getCallsForBatch(this.$route.params.QCCampaignId, this.batchId, params).then(
                result => {
                    this.activeCall = result.data.results[0]
                    this.renderCurrentWork()
                }
            ).catch(error => {
                if (error.response.status === 404) {
                    this.$router.push({
                        path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                        query: {
                            tab: 'batch',
                        }
                    })
                }
            })
        },
        convertCriteria() {
            this.criteria = [];
            for (let i = 0; i < this.criteriaList.length; i++) {
                let criteria = this.criteriaList[i];
                this.criteria.push({
                    type: criteria.type,
                    name: criteria.name,
                    id: criteria.id,
                    config: criteria.config !== "" ? JSON.parse(criteria.config) : [],
                    value: "",
                    description: criteria.description,
                    is_required: criteria.is_required
                });
            }
        },
        convertASRCriteria() {
            this.asrCriteria = [];
            for (let i = 0; i < this.asrCriteriaList.length; i++) {
                let asrCriteria = this.asrCriteriaList[i];
                this.asrCriteria.push({
                    type: asrCriteria.type,
                    name: asrCriteria.name,
                    id: asrCriteria.id,
                    config: asrCriteria.config !== "" ? JSON.parse(asrCriteria.config) : [],
                    value: "",
                    description: asrCriteria.description,
                    is_required: asrCriteria.is_required
                });
            }
        },
        getStatusStatistics() {
            let qcCampaignId = this.$route.params.QCCampaignId
            if (!qcCampaignId || !this.batchId) {
                return
            }

            QcCampaignService.getQCStatusStatistics(
                qcCampaignId,
                this.batchId
            ).then(result => {
                this.statusCallStatistics = {...result.data};
            });
        },
        renderCurrentWork() {
            this.isLoadingRightEditor = true
            this.resetCurrentWork()
            this.loadQcCallRecord()

            this.loadQcCall()
            this.loadCallHistory()
            this.loadCallAudio()
            this.setInProgress()
        },
        saveRecord(isNextCall) {
            this.isLoadingRightEditor = true
            // get list criteria need create new or update
            let criteria = this.getCriteriaCreateOrUpdate();
            // check list empty
            if (criteria.length === 0 && !this.activeLogId) {
                if (!isNextCall) {
                    this.$appService.toastInfo(this.$f.tc('nothingChanges'))
                }
                this.isLoadingRightEditor = false
                return Promise.resolve()
            }

            let promises = criteria.map(item =>
                this.createOrUpdateCallRecord(item.recordId, item.criteriaId)
            );
            if (this.activeLogId) {
                promises = [this.saveRecordSentence(), ...promises];
            }

            return Promise.all(promises)
                .then(() => {
                    this.checkStatusCallQC();
                    this.loadQcCallRecord();
                    this.$appService.toastSuccess(this.$f.tc("saveQCCallSuccess"));
                })
                .finally(() => {
                    this.isLoadingRightEditor = false
                });
        },
        getCriteriaCreateOrUpdate() {
            let criteriaCreateOrUpdate = [];
            for (let criteriaId in this.model) {
                let criteria = this.criteria.find(
                    criteria => criteria.id === criteriaId
                );
                if (criteria.value === this.model[criteriaId]) {
                    continue;
                }

                let record = this.callRecords.find(
                    record => record.criteria.id === criteriaId
                );
                criteriaCreateOrUpdate.push({
                    recordId: record ? record.id : "",
                    criteriaId: criteriaId
                });
            }

            return criteriaCreateOrUpdate;
        },
        createOrUpdateCallRecord(recordId, criteriaId) {
            if (recordId) {
                return QcCampaignService.updateCallRecord(
                    this.$route.params.QCCampaignId,
                    this.batchId,
                    this.activeCall.batch.id,
                    recordId,
                    {
                        result: this.model[criteriaId],
                        comment: ""
                    }
                );
            }

            return QcCampaignService.createCallRecord(
                this.$route.params.QCCampaignId,
                this.batchId,
                this.activeCall.batch.id,
                {
                    criteria_id: criteriaId,
                    result: this.model[criteriaId],
                    comment: ""
                }
            );
        },
        checkStatusCallQC() {
            let callQCId = this.activeCall.batch.id;
            return QcCampaignService.checkStatusCallQC(this.$route.params.QCCampaignId, callQCId).then(result => {
                if (result?.data?.status === this.callQCDetail.status) {
                    return
                }

                this.callQCDetail = result.data
                let currentStatus = result?.data?.status === "done" ? this.$t("done") : this.$t("inProgress")
                this.$appService.toastSuccess(this.$f.tc("changeStatusQC", [currentStatus]))
                this.getStatusStatistics()
            }).finally(() => {
                this.isLoadingRightEditor = false
            })
        },
        loadQcCall() {
            return QcCampaignService.getQCCall(
                this.$route.params.QCCampaignId,
                this.batchId,
                this.activeCall.batch.id
            )
                .then(result => {
                    this.callQCDetail = result.data;
                    let dataInput = JSON.parse(result.data["meta_data"]);
                    for (let source in dataInput) {
                        for (let key in dataInput[source]) {
                            let item = {
                                source: source,
                                key: key,
                                value: dataInput[source][key]
                            };
                            this.activeCallInputData.push(item);
                        }
                    }
                })
        },
        loadQcCallRecord() {
            // Hiện backend đang xử lý khi nào chuyển trạng thái sang sin_progress thì mới có default cho record
            // nên việc gọi khi ở trạng thái to_do sẽ trả về []
            if (!['in_progress', 'done'].includes(this.activeCall.batch.status)) {
                return
            }
            this.isLoadingRightEditor = true
            QcCampaignService.getCallRecord(this.$route.params.QCCampaignId, this.batchId, this.activeCall.batch.id).then(
                result => {
                    this.callRecords = result.data
                    for (let i = 0, l = this.callRecords.length; i < l; i++) {
                        let recordCriteriaId = this.callRecords[i].criteria.id
                        let criteria = this.criteria.find(criteria => criteria.id === recordCriteriaId)
                        criteria.value = this.callRecords[i].result
                        this.model[criteria.id] = this.callRecords[i].result
                    }
                }
            ).finally(() => {
                this.isLoadingRightEditor = false
            })
        },
        loadCallAudio() {
            if (this.$refs.audio) {
                this.$refs.audio.pause()
                this.$refs.audio.currentTime = 0
            }

            this.loadingAudio = true;
            let callQCId = this.activeCall.batch.id;
            return QcCampaignService.getCallAudio(callQCId)
                .then(result => {
                    this.callQCAudio = result.data;
                    this.callQCAudioSrc = window.URL.createObjectURL(
                        new Blob([result.data], {type: "audio/wav"})
                    );
                })
                .catch(() => {
                    this.$appService.toastError(
                        this.$f.tc("canNotLoadCallAudio") + ": " + this.activeCall.batch.call_id
                    );
                })
                .finally(() => {
                    this.loadingAudio = false;
                });
        },
        updateMessageList(logList) {
            let list = []
            let index = -1

            // In this case, you should use for rather than forEach because it requires a break
            for (let log of logList) {
                index += 1
                let middleNode = log.nodes_flow ? log.nodes_flow.middle_node : null
                let userSay = {
                    type: 'user',
                    log_id: log.log_id ? log.log_id : '',
                    asr_model_name: log.asr_model_name ? log.asr_model_name : '',
                    decisionNode: middleNode && middleNode.type === NodeType.DECISION ? middleNode : null,
                    asr_audio_path: log.asr_audio_path
                }

                if (log.input.type === 'end_call') {
                    userSay.content = '-----end call-----'
                    list.push(userSay)
                    break
                }

                if (log.input.type === 'payload' && log.input.content === 'welcome') {
                    userSay.content = '-----new conversation-----'
                } else {
                    userSay.content = log.input.content
                    userSay.nlp = {
                        intent: (log.nlp_response && log.nlp_response.intents && log.nlp_response.intents[0])
                            ? log.nlp_response.intents[0]
                            : null,
                        entities: log.nlp_response ? log.nlp_response.entities : []
                    }
                }

                // check case silence because node 0s
                if (userSay.content.trim() !== 'get_more_prompt' && logList[index - 1]?.output.setting?.record_time !== '0') {
                    list.push(userSay)
                }

                list.push({
                    type: 'bot',
                    content: log.output.prompt
                })

                this.callQCDetail.bot_name = log.bot_name ? log.bot_name : ''
            }

            this.activeCallHistory.messageList = list
        },
        loadCallHistory() {
            this.loadingMessage = true;
            return QcCampaignService.getQCCallHistory(
                this.activeCall.batch.call_id
            )
                .then(result => {
                    let logList = lodash.orderBy(result.data, "created_time");
                    this.updateMessageList(logList);
                })
                .finally(() => {
                    this.loadingMessage = false;
                });
        },
        nextCall() {
            if (this.batchStatus === 'close') {
                return
            }

            let model = {
                is_perform_qc: this.isPerformQC,
                index: this.indexCall
            }

            this.saveRecord(true).then(() => {
                this.checkStatusCallQC()
            }).then(() => {
                QcCampaignService.getNextQcCall(
                    this.$route.params.QCCampaignId,
                    this.batchId,
                    model
                ).then(result => {
                    if (Object.keys(result.data).length === 0) {
                        this.$appService.toastError(this.$f.tc('noMoreQcCalls'))
                        return
                    }
                    this.updateIndexCall(result.data.index)
                })
            })
        },
        updateIndexCall(newIndex) {
            this.$store.commit(this.$actionTypes.qccampaign.SET_INDEX_CALL, newIndex)
            let query = this.$utils.cloneObject(this.$route.query);
            if (query.callIndex !== newIndex) {
                this.search()
                query.callIndex = newIndex;
                this.$router.push({
                    path: `/qc-campaign/${this.$route.params.QCCampaignId}/`,
                    query: query
                });
            } else {
                this.isLoadingRightEditor = false
            }
        },
        resetCurrentWork() {
            this.model = {}
            for (const element of this.criteria) {
                element.value = ''
            }

            this.activeCallInputData = []
            this.callRecords = []
            this.activeCallHistory.messageList = []
            this.closeQcSentence()
        },
        copyText(text) {
            this.$utils.copyToClipboard(text, this.$f.tc('copied'))
        },
        getText(item) {
            if (item.value === '') {
                return ''
            }
            return item.value + ' (' + item.description + ')'
        },
        setInProgress() {
            if (this.activeCall.batch.status === 'in_progress' || this.activeCall.batch.status === 'done') {
                return
            }

            if (this.batch.status === 'close') {
                this.$appService.toastInfo(this.$f.tc('batchHasCloseNotChangeStatusCall'))
                return
            }

            QcCampaignService.updateCallStatus(
                this.$route.params.QCCampaignId,
                this.batchId,
                this.activeCall.batch.id,
                {
                    status: "in_progress",
                    qc_by: this.profile.email
                }
            ).then(result => {
                this.callQCDetail = result.data;
                this.activeCall.batch = result.data // result.data sẽ chứa nhiều giá trị hơn khi gán thế này
                this.$appService.toastSuccess(
                    this.$f.tc("changeStatusQC", [this.$f.tc("inProgress")])
                );
                this.loadQcCallRecord()
                this.getStatusStatistics();
            })
        },
        async qcSentence(item) {
            if (this.activeLogId) {
                await this.saveRecordSentence()
            }

            let model = {
                log_id: item["log_id"],
                asr_audio_path: item.asr_audio_path ? item.asr_audio_path : "",
                asr_model_name: item["asr_model_name"],
                asr_output: item["content"],
                decision_node: item.decisionNode ? item.decisionNode.name : "",
                nlp_intent: item.nlp.intent ? item.nlp.intent.label : "",
                nlp_confidence: item.nlp.intent ? item.nlp.intent.confidence : 1
            };
            this.isLoadingRightEditor = true;
            // Get or create qc for sentence
            QcCampaignService.getOrCreateSentenceQc(
                this.activeCall.batch.id,
                model
            ).then(async sentenceRes => {
                this.activeSentence = sentenceRes.data;
                this.activeSentenceId = sentenceRes.data["id"];
                this.activeLogId = sentenceRes.data["log_id"];

                // Get record qc sentence if exist
                const recordRes = await QcCampaignService.getRecordSentenceQc(
                    this.activeCall.batch.id,
                    this.activeSentenceId
                );
                this.recordSentence = recordRes.data;
                this.asrModel = {};
                for (let i = 0, l = this.recordSentence.length; i < l; i++) {
                    let asrCriteriaId = this.recordSentence[i]["asr_criteria"];
                    this.asrModel[asrCriteriaId] = this.recordSentence[i].result;
                }
            }).catch(error => {
                if (error.response.status === 404) {
                    this.$appService.toastWarning(error.response.data.message)
                }
            }).finally(() => {
                this.isLoadingRightEditor = false;
            });
            // get asr audio if exist
            this.asrDateExpired = ''
            if (this.callCampaign && this.callCampaign["save_asr_audio"] && item.asr_audio_path) {
                return QcCampaignService.getAsrAudio(item.asr_audio_path)
                    .then(result => {
                        this.asrAudioSrc = window.URL.createObjectURL(
                            new Blob([result.data], {type: "audio/wav"})
                        )
                        this.asrDateExpired = this.updateAsrDateExpired(item.asr_audio_path)
                    })
                    .catch(() => {
                        this.$appService.toastError(
                            this.$f.tc("canNotLoadCallAudio") + ": " + item.asr_audio_path
                        )
                    })
            }
        },
        updateAsrDateExpired(filePath) {
            const match = filePath.match(/\/(\d+)\.wav$/);
            if (match) {
                let timeStamp = parseInt(match[1], 10)
                let date = moment.unix(timeStamp)
                // Format the date
                return date.add(30, 'days').format('DD/MM/YYYY')
            }
            return ''
        },
        closeQcSentence() {
            this.activeLogId = ''
            this.activeSentenceId = ''
            this.activeSentence = {}
            this.recordSentence = []
        },
        saveRecordSentence() {
            let model = []
            for (let asrCriteriaId in this.asrModel) {
                model.push({
                    asr_criteria_id: asrCriteriaId,
                    result: this.asrModel[asrCriteriaId],
                    comment: ""
                });
            }

            return QcCampaignService.createOrUpdateRecordSentenceQc(
                this.activeCall.batch.id,
                this.activeSentenceId,
                model
            )
                .then(() => {
                    this.$appService.toastSuccess(this.$f.tc("saveQCSentenceSuccess"));
                    this.checkStatusCallQC();
                })
                .finally(() => {
                    this.closeQcSentence();
                });
        },
        onClearCriteria(criteriaId, isASR = true) {
            this.$nextTick(() => {
                if (isASR) {
                    this.asrModel[criteriaId] = ""
                } else {
                    this.model[criteriaId] = ""
                }
            })
        },
        checkNLPMapConditions(nlp) {
            if (!nlp) return false;

            let result = {
                isValid: false,
                from: 0,
                to: 1
            }
            const confidence = nlp?.intent?.confidence || 1
            for (let condition of this.conditionNLPList) {
                if (confidence >= condition.from && confidence <= condition.to) {
                    result.isValid = true
                    result.from = condition.from || 0
                    result.to = condition.to || 1
                    break
                }
            }

            return result
        },
        getClassUserMsg(itemMsg) {
            // if (itemMsg['log_id'] === this.activeLogId) {
            //     return this.checkNLPMapConditions(itemMsg.nlp) ? 'message-confidence-invalid' : 'message-activated'
            // }
            //
            // return this.checkNLPMapConditions(itemMsg.nlp) ? 'user-invalid': ''
            return itemMsg['log_id'] === this.activeLogId ? 'message-activated' : ''
        }
    },
    watch: {
        criteriaList: {
            deep: true,
            handler: "convertCriteria"
        },
        asrCriteriaList: {
            deep: true,
            handler: "convertASRCriteria"
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/views/Scenario/chat.scss";

.status-tag {
    display: flex;
    align-items: center;
    font-family: "open sans", serif;
    font-size: 13px;
    margin-right: 12px;

    .color-status {
        height: 14px;
        width: 14px;
        border-radius: 50%;
        margin-right: 4px;

        &.todo {
            background: #8a97aa;
        }

        &.in-progress {
            background: #4097bf;
        }

        &.done {
            background: #92c353;
        }
    }
}

.content-page {
    .btn-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #eef6ff;
        color: #0052cc;
        font-size: 13px;
        font-family: "open sans", serif;
        cursor: pointer;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;

        &:hover {
            background: #c4daf6;
        }
    }

    .btn-custom-normal {
        height: 39px !important;
        border-radius: 0 !important;
        justify-content: left;
        color: #0052CC;
        font-size: 14px;
        font-family: "open sans bold", serif;
        font-style: normal;
        text-align: center;
    }
}

.access-status {
    background: #8A97AA !important;
    color: #ffffff !important;
    gap: 6px;
    margin-left: 6px;
    cursor: default !important;
}

.call-history, .qc-content {
    overflow-y: auto;
}

.data-input {
    width: 400px;
    overflow-y: auto;
    border: 1px solid #e4edfa;
    font-family: "open sans", serif;
    font-size: 14px;

    table {
        width: 100%;
        border-spacing: 0;

        thead {
            background: #F0F0F0;

            th {
                text-align: left;
                font-family: "open sans semi", serif;
            }
        }

        tr {
            height: 44px;
        }

        th, td {
            padding: 0 10px;
            border-bottom: 1px solid #DADFEC;
        }
    }
}

.call-history {
    flex: 1;
    border-right: 1px solid #e4edfa;
}

.qc-content {
    width: 450px;
    padding: 0;
}

.message-activated {
    border: 2px solid #0052CC !important;
    background: #0a6cff1a !important;
    color: #0052CC !important;
    font-family: "open sans semi", serif !important;
}

.user-invalid {
    background: #e3a008 !important;
    color: #fff !important;
}

.message-confidence-invalid {
    border: 2px solid #e3a008 !important;
    background: #8d4b0f1a !important;
    color: #e3a008 !important;
    font-family: "open sans semi", serif !important;
}

.nlp-confidence {
    color: #0052CC;
    margin-left: 3px;
    cursor: default;
}

.nlp-warning {
    color: #e3a008;
    font-weight: bold;
    font-size: 13px;
}

.message-scroll {
    height: calc(100vh - 365px);
    overflow: auto;
    padding: 0 5px 10px 10px;
    margin-right: 5px;
}

.nlp-container {
    text-align: right;
    font-size: 12px;
    margin-right: 4px;
    margin-top: 3px;
}

.call-audio {
    display: flex;
    align-items: center;
    padding: 10px;

    audio {
        width: 100%;
        height: 30px;
    }
}

.title-qc {
    height: 46px;
    display: flex;
    align-items: center;
    background: #F0F0F0;
    font-family: "open sans semi", serif;
    font-size: 14px;
    padding: 0 10px;
}

.item-qc {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }

    .item-criteria {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: "open sans", serif;
        margin-bottom: 6px;
    }
}

.textarea-desc {
    ::v-deep {
        .v-input__slot {
            border: none !important;

            textarea {
                color: white;
                font-size: 13px;
            }
        }
    }
}

.input-custom, .textarea-custom {
    ::v-deep {
        .v-input__slot {
            font-family: "open sans", serif;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            textarea {
                padding: 6px 12px;
            }

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 36px;
            line-height: 36px;
            padding: 6px 12px;
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 11px
    }

    .v-select {
        .v-input__slot {
            padding-right: 6px !important;
        }

        .v-text-field__details {
            right: 32px;
        }
    }
}
</style>
